import React, { useEffect, useState } from 'react';

const AchievementModal = ({ isOpen, onClose, initialName = '', initialIssuer = '', initialStart = '', initialEnd = '', initialDetails = '', onSave, onEnhance }) => {
  const [name, setName] = useState(initialName || '');
  const [issuer, setIssuer] = useState(initialIssuer || '');
  const [startDate, setStartDate] = useState(initialStart || '');
  const [endDate, setEndDate] = useState(initialEnd || '');
  const [details, setDetails] = useState(initialDetails || '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setName(initialName || '');
    setIssuer(initialIssuer || '');
    setStartDate(initialStart || '');
    setEndDate(initialEnd || '');
    setDetails(initialDetails || '');
  }, [initialName, initialIssuer, initialStart, initialEnd, initialDetails, isOpen]);

  if (!isOpen) return null;

  const handleEnhance = async () => {
    if (!onEnhance) return;
    try {
      setLoading(true);
      const inputText = `${name}${issuer ? '\n' + issuer : ''}`;
      const enhanced = await onEnhance(inputText);
      if (enhanced) {
        const lines = String(enhanced).split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
        if (lines.length >= 1) setName(lines[0]);
        if (lines.length >= 2) setIssuer(lines[1]);
      }
    } catch (err) {
      console.error('AchievementModal enhance error', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
    if (onSave) onSave({ name: name || '', issuer: issuer || '', startDate, endDate, details });
  };

  return (
    <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, background: 'rgba(0,0,0,0.4)' }}>
      <div style={{ width: 720, maxWidth: '95%', background: '#fff', borderRadius: 6, padding: 20, boxShadow: 'rgba(0,0,0,0.2) 0px 6px 24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>Edit Achievement</h3>
          <button aria-label="Close" onClick={onClose} style={{ background: 'transparent', border: 'none', fontSize: 20 }}>×</button>
        </div>

        <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Achievement name</label>
        <input type="text" placeholder="Achievement name" value={name} onChange={(e) => setName(e.target.value)} className="section-input" style={{ width: '100%', marginBottom: 8 }} />

        <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Issued by</label>
        <input type="text" placeholder="Issued by" value={issuer} onChange={(e) => setIssuer(e.target.value)} className="section-input" style={{ width: '100%', marginBottom: 8 }} />

        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <div style={{ flex: 1 }}>
            <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Start date</label>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="section-input-date" style={{ width: '100%' }} />
          </div>
          <div style={{ flex: 1 }}>
            <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>End date</label>
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="section-input-date" style={{ width: '100%' }} />
          </div>
        </div>

        <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Achievement details</label>
        <textarea rows={8} className="form-textarea" value={details} onChange={(e) => setDetails(e.target.value)} placeholder="Add achievement details or notes." style={{ width: '100%' }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 12 }}>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
            <button type="button" className="btn btn-secondary" onClick={handleEnhance} disabled={loading}>{loading ? 'Enhancing...' : 'Enhance with AI'}</button>
          </div>
          <button type="button" className="btn btn-primary" onClick={() => { handleSave(); onClose(); }}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default AchievementModal;
